import { NotifyService } from './notify.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notify',
  templateUrl: './notify.component.html',
  styleUrls: ['./notify.component.scss']
})
export class NotifyComponent implements OnInit {

  constructor(private modalService: NotifyService) { }

  ngOnInit(): void {
  }

  openModal() {
    this.modalService.openModal();
  }

  closeModal(){
    this.modalService.closeModal();
  }

}
